<div [className]="getClassName()">
    <h2 *ngIf="options.designClass != 'kloeber'">{{"title.article" | translate}}</h2>
    <app-basket-folder [level]="0" [folder]="itemsFirstFolder" [firstFolder]="true" [options]="options"></app-basket-folder>
    <app-basket-buttons *ngIf="options.designClass != 'kloeber'" [options]="options"></app-basket-buttons>
</div>